<template>
<v-container grid-list-md text-xs-center >

    <v-flex xs12>
        <v-row>
      
            <!-- CUADRO 1 - ARCHIVOS M -->
            <v-col cols="12" sm="6" lg="4">
                <base-material-stats-card id="1" :key="'B'+total_correo_m+ total_sistema_m" :selected="selected==1" color="cyan darken-1" subTextColor="cyan darken-1" icon="mdi-file-powerpoint-outline" title="BANDEJA DE CORREO " :value="total_correo_m" :smallValue="total_sistema_m" subtitle="SISTEMA" subColor="black--text" sub-icon="mdi-text-box-plus-outline" sub-text="Archivos M" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'PERIODO: '+ model.fecha_de + ' - ' + model.fecha_a" :onClickBtn1="opendialog1" />
            </v-col>
            <!-- CUADRO 2 - CFDI -->
            <v-col cols="12" sm="6" lg="4">
                <base-material-stats-card id="2" :key="'C'+ total_correo_x+ total_sistema_x" :selected="selected==2" color="amber accent-4" subTextColor="amber accent-4" icon="mdi-cloud-tags" title="BANDEJA DE CORREO" :value="total_correo_x" :smallValue="total_sistema_x" subtitle="SISTEMA" subColor="black--text" sub-icon="mdi-xml" sub-text="CFDI Comercio Exterior" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'PERIODO: '+ model2.fecha_de + ' - ' + model2.fecha_a" :onClickBtn1="opendialog2" />
            </v-col>

            <!-- CUADRO 3 - CP -->
            <v-col cols="12" sm="6" lg="4">
                <base-material-stats-card id="3" :key="'D'+ total_correo_c+ total_sistema_c" :selected="selected==3" color="info" subTextColor="info" icon="mdi-qrcode" title="BANDEJA DE CORREO" :value="total_correo_c" :smallValue="total_sistema_c" sub-icon="mdi-qrcode-plus" sub-icon-color="green" subtitle="SISTEMA" sub-text="CFDI CARTA PORTE" subColor="black--text" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'PERIODO: '+ model3.fecha_de + ' - ' + model3.fecha_a" :onClickBtn1="opendialog3" />
            </v-col>

        </v-row>
        <v-dialog v-model="dialog1" max-width="600px">
            <v-card>

                <v-card-text>
                    <h5>Bandeja de Archivos M</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-form ref="form1" v-model="valid" lazy-validation>
                            <v-row no-gutters dense>
                                <v-col>
                                    <v-menu offset-x ref="menuA1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[validaMes(model.fecha_de, model.fecha_a), validaFechas(model.fecha_de, model.fecha_a)]"></v-text-field>
                                        </template>

                                        <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu1 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col>
                                    <v-menu offset-x ref="menuA2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[validaMes(model.fecha_de, model.fecha_a), validaFechas(model.fecha_de, model.fecha_a)]"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu2 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>

                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialog1 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; selected=1; cargar();">Consultar</v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card v-if="selected==1" class="elevation-1 " >
            <v-card class="pa-2 cyan darken-1 white--text" style="margin-bottom:0px;">
                <v-icon small class="white--text">list</v-icon>&nbsp;
                BANDEJA DE ENTRADA ARCHIVOS M
            </v-card>
            <v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <exportar-excel :key="'export'+ selected"  :data="datafiltered" :exportFields="tabla1.data_excel" name="Consulta_Archivos_M.xlsx">
                        <v-btn icon small dark color="success" title="Exportar Bitácora" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>
                </v-card-actions>

                <v-client-table id="vuetable1" ref="vuetable1" :key="'vuetable'+ selected" :data="datos" :columns="tabla1.columns" :options="tabla1.options">
                    <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>

                    <template slot="rfc_grupo" slot-scope="props">
                        <div v-if="es_grupo==0" @click="openModalAsignar(props.row)" :class="['showPerfil']">
                            {{ getRfcGrupo(props.row.rfc_grupo) }}
                        </div>
                        <div v-else>
                            {{ props.row.rfc_grupo }}
                        </div>
                    </template>

                    <template slot="actions" slot-scope="props">
                        <v-btn x-small fab dark icon color="red" title="Proforma ArchivoM" v-show="(props.row.key_pdf!=null && props.row.key_pdf!='')" @click="download_pdf(props.row.key_pdf)" v-tippy>
                            <v-icon dark>picture_as_pdf</v-icon>
                        </v-btn>
                        <v-btn v-if="permiso_eliminar_m" x-small fab dark icon color="red" title="Eliminar"  @click="eliminarReporte(props.row.id)" v-tippy>
                            <v-icon dark>delete</v-icon>
                        </v-btn>
                        <v-btn v-if="false" x-small fab dark icon color="primary" title="Descargar Archivo ZIP" @click="download(props.row)" v-tippy>
                            <v-icon dark>get_app</v-icon>
                        </v-btn>

                    </template>

                </v-client-table>

            </v-card-text>

        </v-card>

        <v-dialog v-model="dialog2" max-width="600px">
            <v-card>
                <v-card-text>
                    <h5>Bandeja CFDI Comercio Exterior</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-form ref="form2" v-model="valid" lazy-validation>
                            <v-row no-gutters dense>
                                <v-col>
                                    <v-menu offset-x ref="menuB1" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="model2.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model2.fecha_de = parseDate(model2.fecha_de)" v-mask="'####-##-##'" :rules="[validaMes(model2.fecha_de, model2.fecha_a), validaFechas(model2.fecha_de, model2.fecha_a)]"></v-text-field>
                                        </template>

                                        <v-date-picker v-model="model2.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu3 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu3 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col>
                                    <v-menu offset-x ref="menuB2" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="model2.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model2.fecha_a= parseDate(model2.fecha_a)" v-mask="'####-##-##'" :rules="[validaMes(model2.fecha_de, model2.fecha_a), validaFechas(model2.fecha_de, model2.fecha_a)]"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="model2.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu4 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu4 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>

                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialog2 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; selected=2; cargar2();">Consultar</v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card v-if="selected==2" class="elevation-1" >
            <v-card class="pa-2 amber accent-4 white--text" style="margin-bottom:0px;">
                <v-icon small class="white--text">list</v-icon>&nbsp;
                BANDEJA DE ENTRADA CFDI COMERCIO EXTERIOR
            </v-card>
            <v-card-text>

                <v-card-actions>

                    <v-spacer></v-spacer>

                    <exportar-excel  :key="'export'+ selected" :data="datafiltered2" :exportFields="tabla2.data_excel" name="CONSULTA_CFDI.xlsx">
                        <v-btn icon small dark color="success" title="Exportar Consulta" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>
                </v-card-actions>

                <v-client-table id="vuetable2" ref="vuetable2" :key="'vuetable'+ selected"  :data="data2" :columns="tabla2.columns" :options="tabla2.options">
                    <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>




                    <template slot="importe" slot-scope="props">
                        <div style="display:flex; justify-content:right;">
                            {{props.row.importe}}
                        </div>
                    </template>

                    <template slot="actions_view" slot-scope="props">
                        <v-btn x-small fab dark icon color="green" v-if="props.row.tipo_cfdi == 'Ingreso' && props.row.clave_pedimento == '' && props.row.id_factura_pedimento != null" title="Generar Complemento CE o CP"  @click="complemento_cecp(props.row.id_factura_pedimento)" v-tippy>
                          <v-icon dark>update</v-icon>
                      </v-btn>&nbsp;
                        <v-btn x-small fab icon dark color="red" v-if="props.row.key_pdf==null || props.row.key_pdf==''" @click="verFacturaProforma(props.row.rfc, props.row.filename)" title="Factura Proforma" v-tippy>
                            <v-icon>picture_as_pdf</v-icon>
                        </v-btn>&nbsp;
                        <v-btn x-small fab icon dark color="red" v-if="props.row.key_pdf!=null && props.row.key_pdf!=''" @click="downloadProforma(props.row.key_pdf)" title="Factura Proforma" v-tippy>
                            <v-icon>picture_as_pdf</v-icon>
                        </v-btn>&nbsp;
                        <v-btn x-small fab icon dark color="primary" v-if="false" @click="downloadFile(props.row.rfc, props.row.folder + '/' + props.row.folder + '_' + props.row.filename)" title="Descargar" v-tippy>
                            <v-icon>mdi-download</v-icon>
                        </v-btn>&nbsp;
                          <v-btn v-if="permiso_eliminar_f" x-small fab dark icon color="red" title="Eliminar"  @click="eliminarCFDI(props.row.id)" v-tippy>
                            <v-icon dark>delete</v-icon>
                        </v-btn>
                    </template>

                </v-client-table>
            </v-card-text>

        </v-card>
        <v-dialog v-model="dialog3" max-width="600px">
            <v-card>
                <v-card-text>
                    <h5>Bandeja CFDI Carta Porte</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-form ref="form2" v-model="valid" lazy-validation>
                            <v-row no-gutters dense>
                                <v-col>
                                    <v-menu offset-x ref="menuC1" v-model="menu5" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="model3.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model3.fecha_de = parseDate(model3.fecha_de)" v-mask="'####-##-##'" :rules="[validaMes(model3.fecha_de, model3.fecha_a), validaFechas(model3.fecha_de, model3.fecha_a)]"></v-text-field>
                                        </template>

                                        <v-date-picker v-model="model3.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu5 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu5 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col>
                                    <v-menu offset-x ref="menuC2" v-model="menu6" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="model3.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model3.fecha_a= parseDate(model3.fecha_a)" v-mask="'####-##-##'" :rules="[validaMes(model3.fecha_de, model3.fecha_a), validaFechas(model3.fecha_de, model3.fecha_a)]"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="model3.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu6 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu6 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>

                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialog3 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; selected=3; cargar3();">Consultar</v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card v-if="selected==3" class="elevation-1">
            <v-card class="pa-2 info accent-4 white--text" style="margin-bottom:0px;">
                <v-icon small class="white--text">list</v-icon>&nbsp;
                BANDEJA DE ENTRADA CFDI CARTA PORTE
            </v-card>
            <v-card-text>

                <v-card-actions>

                    <v-spacer></v-spacer>

                    <exportar-excel :key="'export'+ selected" :data="datafiltered3" :exportFields="tabla3.data_excel" name="CONSULTA_CARTA_PORTE.xlsx">
                        <v-btn icon small dark color="success" title="Exportar Consulta" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>
                </v-card-actions>

                <v-client-table id="vuetable3" ref="vuetable3" :key="'vuetable'+ selected"  :data="data3" :columns="tabla3.columns" :options="tabla3.options">
                    <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>
                     <template slot="importe" slot-scope="props">
                        <div style="display:flex; justify-content:right;">
                            {{props.row.importe}}
                        </div>
                    </template>
                       <template slot="numero_archivo" slot-scope="props">
                        <div style="width:150px">
                            {{props.row.numero_archivo.substr(0, 23)}}
                        </div>
                    </template>
                    <template slot="actions" slot-scope="props">
                      <v-btn v-if="permiso_refacturar" x-small fab dark icon color="green" title="Re-Facturar"  @click="model_refacturar.tipo = props.row.tipo_cfdi; preparar_refactura(props.row.id)" v-tippy>
                        <v-icon dark>refresh</v-icon>
                    </v-btn>
                        <v-btn v-if="props.row.origen != 'carta_porte'" x-small fab dark icon color="red" title="Proforma Carta Porte" v-show="(props.row.key_pdf!=null && props.row.key_pdf!='')" @click="download_pdf(props.row.key_pdf)" v-tippy>
                            <v-icon dark>picture_as_pdf</v-icon>
                        </v-btn>
                        <v-btn v-if="props.row.origen != 'carta_porte'" x-small fab icon dark color="primary"  @click="downloadFileXML(props.row.key)" title="Descargar XML" v-tippy>
                            <v-icon>mdi-file</v-icon>
                        </v-btn>
                          <v-btn v-if="permiso_eliminar_c" x-small fab dark icon color="red" title="Eliminar"  @click="eliminarCarta(props.row.key)" v-tippy>
                            <v-icon dark>delete</v-icon>
                        </v-btn>

                    </template>

                </v-client-table>
            </v-card-text>

        </v-card>

          <v-row ref="graficas_area" style="margin:0 !important; padding:0 !important" v-if="manifiesto==1 &&  $local_storage.get('id_grupo')>0 && $local_storage.get('es_transportista') == 0">
        <!-- GRAFICA 1 -->
        <v-col cols="12" lg="4" style="padding-top:0px;">
            <div ref="grafica3">
                <base-material-chart-card :options="data_grafica1" color="light-blue darken-4" type="Bar">

                    <h5 class="card-title font-weight-light mt-2 ml-2">Procesos por Mes</h5>


                    <div class="pl-12">
                        <v-btn class="mr-1 secondary--text" light icon title="Seleccionar Año" @click="dialog11 = !dialog11" v-tippy>
                            <v-icon>mdi-calendar</v-icon><span class="caption secondary--text  font-weight-light">{{g1_fecha_de}} - {{g1_fecha_a}}</span>
                        </v-btn>

                    </div>
                </base-material-chart-card>
                <v-dialog v-model="dialog11" max-width="500px">
                    <v-card>

                        <v-card-text>
                            <h5>Procesos por Mes</h5>
                            <v-form ref="form1" v-model="valid" lazy-validation>
                            <v-row no-gutters dense>
                                <v-col>
                                    <v-menu offset-x ref="menuG1" v-model="menu7" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="g1_fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="g1_fecha_de = parseDate(g1_echa_de)" v-mask="'####-##-##'" :rules="[validaFechas(g1_fecha_de, g1_fecha_a)]"></v-text-field>
                                        </template>

                                        <v-date-picker v-model="g1_fecha_de" color="secondary" scrollable locale="es-mx" @input="menu7 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu7 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col>
                                    <v-menu offset-x ref="menuG2" v-model="menu8" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="g1_fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="g1_fecha_a= parseDate(g1_fecha_a)" v-mask="'####-##-##'" :rules="[ validaFechas(g1_fecha_de, g1_fecha_a)]"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="g1_fecha_a" color="secondary" scrollable locale="es-mx" @input="menu8 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu8 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>

                            </v-row>
                        </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog11 = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="estadisticaGrafica1">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>

        </v-col>

        <!-- GRAFICA 2 -->
        <v-col cols="12" lg="4" style="padding-top:0px;">
            <div ref="grafica2">
                <base-material-chart-card :options="data_grafica2" color="teal darken-4" type="Bar">

                    <h5 class="card-title font-weight-light mt-2 ml-2">Procesos por Transportista</h5>


                     <div class="pl-12">
                        <v-btn class="mr-1 secondary--text" light icon title="Seleccionar Año" @click="dialog22 = !dialog22" v-tippy>
                            <v-icon>mdi-calendar</v-icon><span class="caption secondary--text  font-weight-light">{{g2_fecha_de}} - {{g2_fecha_a}}</span>
                        </v-btn>

                    </div>
                </base-material-chart-card>
                <v-dialog v-model="dialog22" max-width="500px">
                    <v-card>

                        <v-card-text>
                            <h5>Procesos por Transportista</h5>
                            <v-form ref="form1" v-model="valid" lazy-validation>
                            <v-row no-gutters dense>
                                <v-col>
                                    <v-menu offset-x ref="menuG2" v-model="menu9" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="g2_fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="g2_fecha_de = parseDate(g2_echa_de)" v-mask="'####-##-##'" :rules="[validaFechas(g2_fecha_de, g2_fecha_a)]"></v-text-field>
                                        </template>

                                        <v-date-picker v-model="g2_fecha_de" color="secondary" scrollable locale="es-mx" @input="menu9 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu9 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col>
                                    <v-menu offset-x ref="menuG2" v-model="menu10" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="g2_fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="g2_fecha_a= parseDate(g2_fecha_a)" v-mask="'####-##-##'" :rules="[ validaFechas(g2_fecha_de, g2_fecha_a)]"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="g2_fecha_a" color="secondary" scrollable locale="es-mx" @input="menu10 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu10 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>

                            </v-row>
                        </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog22 = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="estadisticaGrafica2">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>

        </v-col>

        <!-- GRAFICA 3 -->
        <v-col cols="12" lg="4" style="padding-top:0px;">
            <div ref="grafica3">
                <base-material-chart-card :options="data_grafica3" color="purple darken-4" type="Bar">

                    <h5 class="card-title font-weight-light mt-2 ml-2">Procesos por Ruta</h5>

                     <div class="pl-12">
                        <v-btn class="mr-1 secondary--text" light icon title="Seleccionar Año" @click="dialog33 = !dialog33" v-tippy>
                            <v-icon>mdi-calendar</v-icon><span class="caption secondary--text  font-weight-light">{{g3_fecha_de}} - {{g3_fecha_a}}</span>
                        </v-btn>

                    </div>
                </base-material-chart-card>
                <v-dialog v-model="dialog33" max-width="500px">
                    <v-card>

                        <v-card-text>
                            <h5>Procesos por Ruta</h5>
                            <v-form ref="form1" v-model="valid" lazy-validation>
                            <v-row no-gutters dense>
                                <v-col>
                                    <v-menu offset-x ref="menuG3" v-model="menu11" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="g3_fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="g3_fecha_de = parseDate(g3_echa_de)" v-mask="'####-##-##'" :rules="[validaFechas(g3_fecha_de, g3_fecha_a)]"></v-text-field>
                                        </template>

                                        <v-date-picker v-model="g3_fecha_de" color="secondary" scrollable locale="es-mx" @input="menu11 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu11 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col>
                                    <v-menu offset-x ref="menuG3" v-model="menu12" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field clearable v-on="on" v-model="g3_fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="g3_fecha_a= parseDate(g3_fecha_a)" v-mask="'####-##-##'" :rules="[ validaFechas(g3_fecha_de, g3_fecha_a)]"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="g3_fecha_a" color="secondary" scrollable locale="es-mx" @input="menu12 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu12 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>

                            </v-row>
                        </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog33 = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="estadisticaGrafica3">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </v-col>

    </v-row>
    </v-flex>

    <v-dialog v-model="modal_cecp" max-width="600px">
      <v-card>
        <v-card-text>
          <h5><b>Generar Complemento CE o CP</b></h5>
          <br>
          <v-container grid-list-md text-xs-center>
            <v-form ref="form_refactura" lazy-validation>
              <h5>Seleccione el tipo de Complemento</h5>
              <v-row no-gutters dense>
                <v-col>
                  <v-autocomplete v-model="model_cecp.tipo" label="Tipo" :items="tipos_cecp"  :hide-no-data="true" item-text="text" item-value="id" :rules="[rules.required]">
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>

          <v-spacer></v-spacer>
          <v-btn small @click="modal_cecp = false">Cancelar</v-btn>
          <v-btn small color="primary" @click="enviar_cecp">Generar</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>

<script>
    import axios from "axios";
    import moment from "moment";
    var colors_bars = [
        "#eb7601", //naranja
        "#ffde17", //amarillo
        "#006594", //azul
        "#56baec", // azul cielo
        "#ffffff" // azul cielo
    ];

export default {
 mounted: function () {

        if(this.$local_storage.get("login") == 1){
            this.manifiesto =  1;
            this.selected=0;
        }
        if(this.$local_storage.get("login") == 0){
            this.manifiesto =  0;
             this.selected=1;

        }
        if(this.$local_storage.get('id_grupo')==0){
            this.selected=1;
        }


        if (this.$local_storage.get('es_transportista') == 1){
            this.selected=1;
        }
        if (this.$local_storage.get('es_agente') == 1){
            this.selected=1;
        }
    },

    data: () => ({
        manifiesto: 0,
        model_refacturar:{
          id:null,
          emisor:null,
          receptor:null,
          uuid_empresa: null,
          tipo: null
        },
        model_cecp: {
            id:null,
            tipo:null
        },
        tipos_cecp: [{
          "id": 1,
          "text": "Comercio Exterior"
        },{
          "id": 2,
          "text": "Carta Porte"
        }],
        URL_C: "",
        receptores: [],
        modal_refacturar:false,
        modal_cecp: false,
        total_correo_m: 0,
        total_sistema_m: 0,
        total_correo_x: 0,
        total_sistema_x:0,
        total_correo_c:0,
        total_sistema_c:0,
        valid: true,
        row_selected:{},
        modal_asignar:false,
        rfc_grupo_asignar:"",
        es_grupo:0,
        gruposTransportistas:[],
        clientesTransportista:[],
        rfc_grupo_seleccionado:"",
        rfc_cliente_seleccionado:"",
        modal_docs: false,
        permisoEliminar: false,
        dialog1: false,
        dialog2: false,
        dialog3: false,
        tab: null,
        selected: 0,
        lista: {
            'coves':[],
            'eDocuments':[]
        },
        data_table_impo: [],
        lista_filtrada: [],
        modal: false,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "",
            },

        ],

        datos: [],
        datos2: [],
        datos3: [],
        data:[],
        data2:[],
        data3:[],
        tabla1: {
        columns: [
            "rfc_grupo",
            "rfc",
            "metadato",
            "fecha",
            "iniciales",
            "origen",
            "nombre_zip",
            "numero_archivo",
            "no_pedimento",
            "fecha_pedimento",
            "clave_pedimento",
            "tipo_operacion",
            "aduana",
            "rfc_cfdi",
            "razon_social_agencia",
            "estatus",
            "actions",
        ],
        options: {
            filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
            sortable: [
            "rfc",
            "metadato",
            "rfc_grupo",
            "fecha",
            "iniciales",
            "origen",
            "nombre_zip",
            "numero_archivo",
            "no_pedimento",
            "fecha_pedimento",
            "clave_pedimento",
            "tipo_operacion",
            "aduana",
            "rfc_cfdi",
            "razon_social_agencia",
            "estatus",
            ],
            orderBy: {
                column: 'fecha',
                ascending: false
            },
            headings: {
                "rfc":"RFC Importador-Exportador",
                "metadato":"Nombre Corto",
                "rfc_grupo":"RFC Grupo Logístico",
                "fecha":"Fecha Proceso",
                "iniciales":"Usuario",
                "origen":"Origen",
                "nombre_zip":"Nombre de Referencia del Proceso",
                "numero_archivo":"Archivo M",
                "no_pedimento":"Número de Pedimento",
                "fecha_pedimento": "Fecha Ped.",
                "clave_pedimento":"Clave",
                "tipo_operacion":"Tipo Operación",
                "aduana":"Aduana ",
                "rfc_cfdi":"RFC Agencia Aduanal",
                "razon_social_agencia":"Razon Social Agencia Aduanal",
                "estatus": "Estatus",
                actions: "Acciones",
            },
        },
        data_excel: {
            "RFC Grupo Logístico":"rfc_grupo",
               "RFC Importador-Exportador":"rfc",
                "Nombre Corto": "metadato",
                "Fecha Proceso":"fecha",
                "Usuario":"iniciales",
                "Origen":"origen",
               "Nombre de Referencia del Proceso": "nombre_zip",
                "Archivo M":"numero_archivo",
                "Número de Pedimento":"no_pedimento",
                "Fecha Ped.": "fecha_pedimento" ,
                "Clave":"clave_pedimento",
               "Tipo Operación": "tipo_operacion",
                "Aduana": "aduana",
                "RFC Agencia Aduanal": "rfc_cfdi",
               "Razon Social Agencia Aduanal":  "razon_social_agencia",
               "Estatus":  "estatus" ,
        },
        },
       tabla2: {
            columns: [
                "rfc_grupo",
                "rfc",
                "metadato_cliente",
                "fecha",
                "iniciales",
                "fuente",
                "nombre_zip",
                "filename",
                "receptor_numero",
                "receptor_nombre",
                "folio",
                "fecha_emision",
                "tipo_cfdi",
                "importe",
                "no_pedimento",
                "fecha_pago",
                "clave_pedimento",
                "tipo_operacion",
                "aduana",
                "rfc_factura",
                "razon_social_agencia",
                "actions_view"
            ],
            options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'fecha',
                    ascending: false
                },
                sortable: [
                    "rfc_grupo",
                    "rfc",
                    "metadato_cliente",
                    "fecha",
                    "iniciales",
                    "fuente",
                    "nombre_zip",
                    "filename",
                    "receptor_numero","receptor_nombre",
                    "folio",
                    "fecha_emision",
                    "tipo_cfdi",
                    "importe",
                     "no_pedimento",
                    "fecha_pago",
                    "clave_pedimento",
                    "tipo_operacion",
                    "aduana",
                    "rfc_factura",
                    "razon_social_agencia",
                ],
                headings: {
                    "rfc_grupo":"RFC Grupo Logístico",
                    "rfc":"RFC Importador-Exportador",
                    "metadato_cliente":"Nombre Corto",
                    "fecha": "Fecha Proceso",
                    "iniciales": "Usuario",
                    "fuente":"Origen",
                    "nombre_zip": "Nombre de Referencia del Proceso",
                    "filename": "Archivo",
                    "receptor_numero":"No. Reg. Receptor",
                    "receptor_nombre":"Nombre del Receptor",
                    "folio": "Folio",
                    "fecha_emision": "Fecha Emision",
                    "tipo_cfdi":"Tipo CFDI",
                    "importe":"Importe",
                    "no_pedimento": "Número de Pedimento",
                    "fecha_pago" : "Fecha Pedimento",
                    "clave_pedimento": "Clave de Documento",
                    "tipo_operacion": "Tipo Operación",
                    "aduana": "Aduana de Despacho",
                     "rfc_factura":"RFC Agencia Aduanal",
                    "razon_social_agencia": "Razon Social Agencia Aduanal",
                    "actions_view": 'Opciones'
                },
            },
            data_excel: {
                   "RFC Grupo Logístico":"rfc_grupo",
                   "RFC Importador-Exportador":"rfc",
                   "Nombre Corto": "metadato_cliente",
                   "Fecha Proceso": "fecha" ,
                   "Usuario": "iniciales" ,
                    "Origen": "fuente",
                   "Nombre de Referencia del Proceso": "nombre_zip",
                    "Archivo":"filename",
                    "No. Reg. Receptor":"receptor_numero",
                    "Nombre del Receptor":"receptor_nombre",
                    "Tipo de Documento":"descripcion" ,
                    "Folio": "folio" ,
                    "Fecha Emision": "fecha_emision" ,
                    "Tipo CFDI": "tipo_cfdi",
                    "Importe":"importe",
                    "Número de Pedimento":"no_pedimento",
                    "Fecha Pedimento": "fecha_pago" ,
                    "Clave de Documento":"clave_pedimento",
                    "Tipo Operación":"tipo_operacion",
                    "Aduana de Despacho": "aduana" ,
                    "RFC Agencia Aduanal": "rfc_factura",
                    "Razon Social Agencia Aduanal": "razon_social_agencia",
            },
       },
       tabla3: {
        columns: [
            "rfc_grupo",
            "rfc",
            "nombre_emisor",
            "rfc_receptor",
            "nombre_receptor",
            "rfc_origen",
            "nombre_origen",
            "rfc_destino",
            "nombre_destino",
            "fecha",
            "iniciales",
            "origen",
            "nombre_zip",
            "numero_archivo",
            "fecha_factura",
            "folio",
            "fecha_emision",
            "tipo_cfdi",
            "importe",
            "numero_pedimento",
            "fecha_pedimento",
            "clave_pedimento",
            "tipo_operacion",
            "aduana",
            "razon_social_agencia",
            "rfc_agencia",
            "actions",
        ],
        options: {
            filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
            orderBy: {
                column: 'fecha',
                ascending: false
            },
            sortable: [
            "rfc_grupo",
            "rfc",
            "nombre_emisor",
            "rfc_receptor",
            "nombre_receptor",
            "rfc_origen",
            "nombre_origen",
            "rfc_destino",
            "nombre_destino",
            "fecha",
            "iniciales",
            "origen",
            "nombre_zip",
            "numero_archivo",
            "fecha_factura",
            "folio",
            "fecha_emision",
            "tipo_cfdi",
            "importe",
            "numero_pedimento",
            "fecha_pedimento",
            "clave_pedimento",
            "tipo_operacion",
            "aduana",
            "razon_social_agencia",
            "rfc_agencia",
            ],
            headings: {
            "rfc_grupo": "RFC Grupo Logístico",
            "rfc": "RFC Transportista",
            "nombre_emisor": "Nombre Corto",
            "rfc_receptor": "RFC Receptor",
            "nombre_receptor" : "Nombre del Receptor",
            "rfc_origen": "NIF Ubicación Origen",
            "nombre_origen": "Nombre Ubicación Origen",
            "rfc_destino": "NIF Ubicación Destino",
            "nombre_destino": "Nombre Ubicación Destinoo",
            "fecha": "Fecha Proceso",
            "iniciales": "Usuario",
            "origen": "Origen",
            "nombre_zip" :"Nombre de Referencia del Proceso",
            "numero_archivo": "Archivo",
            "folio": "Folio",
            "fecha_emision": "Fecha Emisión",
            "tipo_cfdi": "Tipo CFDI",
            "importe": "Importe",
            "numero_pedimento": "Número de Pedimento",
            "fecha_pedimento": "Fecha de  Pedimento",
            "clave_pedimento": "Calve Documento",
            "tipo_operacion": "Tipo Operación",
            "aduana" : "Aduana Despacho",
            "rfc_agencia": "RFC Agencia Aduanal",
            "razon_social_agencia": "Razón Social Agencia Aduanal",
            actions: "Acciones",
            },
        },
         data_excel: {
             "RFC Grupo Logístico":"rfc_grupo",
            "RFC Transportista": "rfc" ,
            "Nombre Corto": "nombre_emisor",
            "RFC Receptor": "rfc_receptor" ,
            "Nombre del Receptor": "nombre_receptor",
            "NIF Ubicación Origen": "rfc_origen",
            "Nombre Ubicación Origen": "nombre_origen",
            "NIF Ubicación Destino": "rfc_destino",
            "Nombre Ubicación Destino": "nombre_destino" ,
            "Fecha Proceso": "fecha" ,
            "Usuario": "iniciales",
            "Origen": "origen" ,
            "Nombre de Referencia del Proceso": "nombre_zip" ,
            "Archivo": "numero_archivo" ,
             "Folio": "folio",
            "Fecha Emisión":"fecha_emision",
            "Tipo CFDI": "tipo_cfdi" ,
            "Importe": "importe" ,
            "Número de Pedimento" : "numero_pedimento" ,
            "Fecha de  Pedimento" : "fecha_pedimento" ,
            "Calve Documento" : "clave_pedimento" ,
            "Tipo Operación" : "tipo_operacion",
            "Aduana Despacho" : "aduana",
            "RFC Agencia Aduanal" : "rfc_agencia" ,
            "Razón Social Agencia Aduanal" : "razon_social_agencia" ,
        },
       },
        loading: true,
        loadingReporte: false,
        model: {
            rfc: [],
            usuario: "",
            fecha_de: "",
            fecha_a: "",
            nombre: "",
            proveedor: "",
            archivos: [],
        },
        model2: {
            rfc: [],
            usuario: "",
            fecha_de: "",
            fecha_a: "",
            nombre: "",
            proveedor: "",
            archivos: [],
        },
        model3: {
            rfc: [],
            usuario: "",
            fecha_de: "",
            fecha_a: "",
            nombre: "",
            proveedor: "",
            archivos: [],
        },
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        menu5: false,
        menu6: false,
        menu7: false,
        menu8: false,
        menu9: false,
        menu10: false,
        menu11: false,
        menu12: false,
        g1_fecha_a:"",
        g1_fecha_de:"",
        g2_fecha_a:"",
        g2_fecha_de:"",
        g3_fecha_a:"",
        g3_fecha_de:"",
        fecha_factura: false,

        rules: {
            required: (v) => !!v || "Este campo es requerido",
            numeric: (value) => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            },
        },

            modal: false,
           data_grafica1: {
                chart: {
                    type: "column",
                    backgroundColor: null,
                    height: 250,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },

                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0.1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                series: [{
                        name: "Procesos",
                        data: [],
                        stack: "Procesos"
                    },

                ]
            },
            totalA_G1: 0,
            totalB_G1: 0,
            data_grafica2: {

                 chart: {
                    type: "column",
                    backgroundColor: null,
                    height: 250,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },
                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0.1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                 series: [{
                        name: "Procesos",
                        data: [],
                        stack: "Procesos"
                    },
                ]
            },
            totalA_G2: 0,
            totalB_G2: 0,
            data_grafica3: {
                chart: {
                    type: "column",
                    backgroundColor: null,
                    height: 250,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },
                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0.1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                series: [{
                        name: "Procesos",
                        data: [],
                        stack: "Procesos"
                    }],
            },
            totalA_G3: 0,
            totalB_G3: 0,
            totalC_G3: 0,
            totalD_G3: 0,
            dialog11: false,
            dialog22: false,
            dialog33: false,


    }),


    created: async function () {


         if (this.$local_storage.get("es_agente")==1) 
            this.$router.replace("/indexAA").catch(() => {}); 

        if (this.$local_storage.get("Modulo14") == 100 && this.$local_storage.get("id_cliente") > 0)
            this.$router.replace("/indexAAC").catch(()=>{}); 
        

        this.URL = this.$hostname ;
        this.URL_C = this.$hostname + "carta_porte/catalogos/";
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.model2.usuario = this.$local_storage.get("id_usuario");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");

        var f_de = new Date();
        var f_a = new Date();

        f_de.setDate(f_de.getDate() - 60);

        let y = f_a.getFullYear();
        let m = f_a.getMonth() + 1;
        let d = f_a.getDate();

        let y_de = f_de.getFullYear();
        let m_de = f_de.getMonth() + 1;
        let d_de = f_de.getDate();

        this.a1 = y;
        this.a2 = y;
        this.a3 = y;
        if (m < 10)
            m = '0' + m;
        if (m_de < 10)
            m_de = '0' + m_de;
        if (d < 10)
            d = '0' + d;
        if (d_de < 10)
            d_de = '0' + d_de;
        this.mesB = y + "-" + m;
        this.mesC = y + "-" + m;
        this.mesD = y;

        let fecha_a = y + "-" + m + "-" + d;
        let fecha_de = y_de + "-" + m_de + "-" + d_de;
        this.model.fecha_de = fecha_de;
        this.model.fecha_a = fecha_a;
        this.model2.fecha_de = fecha_de;
        this.model2.fecha_a = fecha_a;
        this.model3.fecha_de = fecha_de;
        this.model3.fecha_a = fecha_a;

        this.g1_fecha_a=fecha_a;
        this.g2_fecha_a=fecha_a;
        this.g3_fecha_a=fecha_a;

        this.g1_fecha_de=y + "-01-01";
        this.g2_fecha_de=y + "-01-01";
        this.g3_fecha_de=y + "-01-01";

        if (this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") == 1) {
            this.model.rfc = [this.$local_storage.get("rfc_grupo")];
            this.model2.rfc = [this.$local_storage.get("rfc_grupo")];
            this.model3.rfc = [this.$local_storage.get("rfc_grupo")];
            this.es_grupo = 1;
           await this.cargar();
           await this.conteos();
        } else if (this.$local_storage.get("id_grupo")>0 && this.$local_storage.get("es_transportista") == 0){
            this.es_grupo = 0; //Se considera que No es grupo, porque tiene que buscar por sus clientes
            //Obtener clientes del grupo y ejecutar busquedas
           await this.carga_clientes_grupo();
           console.log('entra');
        } else {
            this.model.rfc = [this.$local_storage.get("rfc")];
            this.model2.rfc = [this.$local_storage.get("rfc")];
            this.model3.rfc = [this.$local_storage.get("rfc")];
            this.es_grupo = 0;
          await  this.cargar();
          await  this.conteos();
        }

},
computed: {
        datafiltered() {
            var x =this.selected;
                let result = [];
            if (this.$refs.vuetable1 != null) {
               result = this.$refs.vuetable1.allFilteredData;
                return result;
            } else {
               result = this.datos;
                return result;
            }
        },
        datafiltered2() {
            var x =this.selected;
                let result = [];
            if (this.$refs.vuetable2 != null) {
               result = this.$refs.vuetable2.allFilteredData;
                return result;
            } else {
               result = this.data2;
                return result;
            }
        },
        datafiltered3() {
            var x =this.selected;
                let result = [];
            if (this.$refs.vuetable3 != null) {
               result = this.$refs.vuetable3.allFilteredData;
                return result;
            } else {
               result = this.data3;
                return result;
            }
        },
        permiso_refacturar(){
            return (
               this.valida_permiso("Emanifiesto.carta.porte.refacturar")
            );
        },
        permiso_eliminar_m(){
            return (
               this.valida_permiso("Emanifiesto.archivom.cargar")
            );
        },
        permiso_eliminar_f(){
            return (
               this.valida_permiso("Emanifiesto.facturas.cargar")
            );
        },
        permiso_eliminar_c(){
            return (
               this.valida_permiso("Emanifiesto.facturas.cargar")
            );
        },
        anios() {
            var f = new Date();
            let a = [];
            let y = f.getFullYear();
            let i = 1;
            for (i; i < 15; i++) {
                a.push(y)
                y = y - 1;
            }
            return a;
        },

    },

    methods: {
         valida_permiso(permiso) {
          return (
              this.$local_storage.get(permiso) == 100
            );
        },
        carga_clientes_grupo: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var data = {
                usuario: this.$local_storage.get("id_usuario"),
                sistema: this.$sistema,
            };

            var url = this.$hostname + "usuarios/get_clientes_usuario/";

            var self = this;
            axios
                .post(url, data)
                .then(function(response) {

                    var clientes = response.data.results;
                    console.log(clientes);
                    clientes.forEach(function(e){
                        self.model.rfc.push(e.rfc);
                        self.model2.rfc.push(e.rfc);
                        self.model3.rfc.push(e.rfc);
                    })
                    self.estadisticaGrafica1();
                    self.estadisticaGrafica2();
                    self.estadisticaGrafica3();
                    self.cargar();
                    self.conteos();

                })
                .catch(function(error) {
                    console.log(error);
                    self.$root.$dialogLoader.hide();
                    this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener clientes del grupo. Favor de comunicarse con soporte.",
                            footer: "",
                        });
                });
        },
        conteos: function(){


            let self = this;

            let data = {};
            if (this.es_grupo == 1 ){
                data = {
                    rfc: [],
                    rfc_grupo: this.model.rfc,
                    fecha_de: this.model.fecha_de,
                    fecha_a: this.model.fecha_a,
                    rfc_receptor: [],
                    rfc_origen: [],
                    rfc_destino: [],
            };
            }else{
                data = {
                    rfc: this.model.rfc,
                    rfc_grupo: [] ,
                    fecha_de: this.model.fecha_de,
                    fecha_a: this.model.fecha_a,
                    rfc_receptor: this.model.rfc,
                    rfc_origen: this.model.rfc,
                    rfc_destino: this.model.rfc,
                };
            }

            axios.post("https://apireportes.econnectpro.mx/reportes/conteos_cartaporte/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {

                        self.total_correo_m = res.data.archivosM.correo;
                        self.total_sistema_m = res.data.archivosM.sistema;
                        self.total_correo_x = res.data.cfdi.correo;
                        self.total_sistema_x = res.data.cfdi.sistema;
                        self.total_correo_c = res.data.carta_porte.correo;
                        self.total_sistema_c = res.data.carta_porte.sistema;
                    }
                })
                .catch(err => {
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        opendialog1: function(){
            this.dialog1=true
        },
        opendialog2: function(){
            this.dialog2=true
        },
        opendialog3: function(){
            this.dialog3=true
        },
        selectItem(index) {
            if(this.selected == index){
                this.selected = 0;
            }else{
                this.selected = index;
                if (index == 1) {
                    this.cargar();

                }
                if (index == 2) {
                    this.cargar2();

                }
                if (index == 3) {
                    this.cargar3();

                }
            }


        },
        validaFechas: function (FD, FA) {
            if (FD == null)
                FD = ""
            if (FA == null)
                FA = ""

            if (FD != "" && FD == "") {
                return "Debe seleccionar las dos fechas o ninguna.";
            } else if (FD == "" && FA != "") {
                return "Debe seleccionar las dos fechas o ninguna.";
            }
            return true;
        },
        validaMes: function (FD, FA) {
            if (FD != "" && FA != "") {
                var inicio = moment(FD, "YYYY-MM-DD");
                var fin = moment(FA, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 60)
                    return "Periodo máximo de consulta 60 días. Favor de verificar.";
            }
            return true;
        },
        getNombreGrupo:function(row){
            return row.rfc+" - "+row.grupo;
        },

        getRfcGrupo: function (val) {
            if (val !== null) return val;
            else return "Sin Seleccionar";
        },
        downloadFile: function (rfc, key) {

            let file = rfc + "/" + key;
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            var datos = {
                id: file,
                bucket: "facturas.abiertas.econectpro.mx",
            };
            axios
                .post(this.$hostname + "s3/download_url/", datos)
                .then((res) => {
                    if (typeof res.data !== "undefined") {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: "",
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (
                        error.response != undefined &&
                        error.response.data != undefined &&
                        error.response.data.mensaje != undefined
                    )
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: "",
                    });
                    console.log(error);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        downloadFileXML: function (key) {

            let file = key;
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            var datos = {
                id: file,
                bucket: "production.econnect.ds",
            };
            axios
                .post(this.$hostname + "s3/download_url/", datos)
                .then((res) => {
                    if (typeof res.data !== "undefined") {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: "",
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (
                        error.response != undefined &&
                        error.response.data != undefined &&
                        error.response.data.mensaje != undefined
                    )
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: "",
                    });
                    console.log(error);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let self = this;
            let fecha = 0;
            if (this.fecha_factura )
                fecha = 1;


            let data = {
                rfc: this.model.rfc,
                es_grupo: this.es_grupo,
                fecha_de: this.model.fecha_de,
                fecha_a: this.model.fecha_a,
                fecha_pedimento : fecha
            };


            axios.post("https://apireportes.econnectpro.mx/reportes/get_bitacora_manifestacion_transportista/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {

                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha) - new Date(a.fecha) ;
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_pedimento = this.parseDate(this.datos[k].fecha_pedimento);
                            this.datos[k].fecha = this.parseDate(this.datos[k].fecha);
                        //    this.datos[k].proveedor = this.datos[k].proveedor==1:"WEB";"API";
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            if(this.datos[k].tipo_operacion == 1)
                                this.datos[k].tipo_operacion = 'Impo';

                            if(this.datos[k].tipo_operacion == 2)
                                this.datos[k].tipo_operacion = 'Expo';
                        }
                        let correo = this.datos.filter(item => {
                                return item.origen == "correo"
                        });

                        self.total_correo_m = correo.length;
                        self.total_sistema_m = this.datos.length - correo.length;


                    }
                })
                .catch(err => {

                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialog1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        cargar2: function () {

                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");


                let data = {
                    rfc: this.model2.rfc,
                    es_grupo: this.es_grupo,
                    fecha_de: this.model2.fecha_de,
                    fecha_a: this.model2.fecha_a,
                };

                data["integrado"] = 0;
                if(data["tipo_comprobante"]==null)
                    data["tipo_comprobante"]="";

                let selft = this;

                data.lista = [];
                data.fecha_factura = false;
                axios({
                        method: "post",
                        url:  "https://apireportes.econnectpro.mx/reportes/facturas_transportista/",
                        data: data,
                    })
                    .then((res) => {


                        this.data2 = res.data;
                        this.data2.forEach(function (r) {
                            r.fecha = r.fecha.substring(0, 10);

                            r.fecha_emision = r.fecha_emision.substring(0, 10);
                            r.fecha_pago = r.fecha_pago.substring(0, 10);

                             if (r.folio == "" )
                                 r.folio = "No Localizado";

                            let a = r.filename.split("_");
                            r.filename = r.filename.substring(a[0].length + 1) + "." + r.ext;
                            r.folder = a[0];


                            let sistema = selft.data2.filter(item => {
                                return item.fuente == "sistema"
                            });

                            if(r.tipo_operacion == 1)
                                r.tipo_operacion = 'Impo';

                            if(r.tipo_operacion == 2)
                                r.tipo_operacion = 'Expo';

                            selft.total_sistema_x = sistema.length;
                            selft.total_correo_x = selft.data2.length - sistema.length;

                        });
                        //console.log(res.data);
                        //console.log(res.data.resumen);
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                        this.dialog2 = false;
                        this.loader = null;
                        this.loading = false;
                    });

        },
        cargar3: function () {

                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");


                let data = {};
                if (this.es_grupo == 1 ){
                    data = {
                        rfc: [],
                        rfc_receptor: [],
                        rfc_origen: [],
                        rfc_destino: [],
                        origen: "" ,
                        rfc_grupo: this.model.rfc,
                        fecha_de: this.model.fecha_de,
                        fecha_a: this.model.fecha_a,
                    };
                }else{
                    data = {
                        rfc: this.model.rfc,
                        rfc_receptor: this.model.rfc,
                        rfc_origen: this.model.rfc,
                        rfc_destino: this.model.rfc,
                        rfc_grupo: [] ,
                        origen: "" ,
                        fecha_de: this.model.fecha_de,
                        fecha_a: this.model.fecha_a,
                    };
                }



                let selft = this;


                axios({
                        method: "post",
                        url: this.URL + "reportes/list_carta_porte/",
                        data: data,
                    })
                    .then((res) => {


                        selft.data3 = res.data;


                        this.data3.forEach(function (r) {
                            r.fecha = r.fecha.substring(0, 10);
                            r.fecha_factura = r.fecha_factura.substring(0, 10);
                            r.fecha_pedimento = r.fecha_pedimento.substring(0, 10);
                            r.fecha_emision = r.fecha_emision.substring(0, 10);

                            if(r.key != null && r.key != "" && r.key != undefined) {
                              r.numero_archivo = r.key.split('/').pop();
                            } else {
                              r.numero_archivo = "";
                            }

                            let sistema = selft.data3.filter(item => {
                                return item.origen == "sistema"
                            });
                             if(r.tipo_operacion == 1)
                                r.tipo_operacion = 'Impo';
                            if(r.tipo_operacion == 2)
                                r.tipo_operacion = 'Expo';

                            if(r.tipo_cfdi == 'T')
                                r.tipo_cfdi = 'Traslado';
                            if(r.tipo_cfdi == 'I')
                                r.tipo_cfdi = 'Ingreso';

                            selft.total_sistema_c = sistema.length;
                            selft.total_correo_c = selft.data3.length - sistema.length;
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                        this.dialog3 = false;
                        this.loader = null;
                        this.loading = false;
                    });

        },

        formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                return ""
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        },

        validaFecha: function (fecha) {
            if (fecha == "Invalid date") return "Fecha no válida.";
            else return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            }
            return true;
        },

        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 365 dias. Favor de verificar.";
            }
            return true;
        },



        getEstatus: function (estatus) {
            var arr_estatus  = ["PROCESADO", "GENERADO", "DUPLICADO", "ARCHIVO NO VALIDO", "ERROR AL GENERAR", "MANIFESTACIÓN TRANSMITIDA"];
            if (estatus in arr_estatus) return arr_estatus[estatus];
            else return estatus;
        },


        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        clear_values() {
            this.model.pedimento = "";
            this.model.fecha_de = "";
            this.model.fecha_a = "";
            this.model.archivo = "";
            this.listado = "";
        },
        verFacturaProforma: function(rfc, filename){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var datos = {
                archivo: filename,
                rfc: rfc
            };

            axios.post(this.$hostname + "reportes_ws/get_data_facturas_pedimentos/", datos)
            .then(response => {
                this.model_proforma = response.data;
                window.URL.revokeObjectURL(this.qrSrc)
                qrCode.toCanvas(this.model_proforma.QRText, {}, this.createObjectUrl)
                this.modalProforma = true;
            })
            .catch(error => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los datos de la factura.",
                    footer: ""
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });

        },
        complemento_cecp: function(id) {
            this.model_cecp.id = id;
            this.model_cecp.tipo = null;

            this.modal_cecp = true;
        },
        enviar_cecp: async function() {
          if(this.model_cecp.tipo != 1 && this.model_cecp.tipo != 2) {
            return;
          }
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

          var datos = {
              id: this.model_cecp.id,
              tipo: this.model_cecp.tipo,
              rfc:  this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") ? this.$local_storage.get("rfc_grupo") : this.$local_storage.get("rfc"),
              uuid: this.$uuid.v4()
          };

          await axios.post(this.$hostname +'carta_porte/generarcecp/', datos).then(async (res) => {
            if (typeof res.data !== 'undefined') {
              console.log(res.data);
              this.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "El registro se envío correctamente.",
                footer: "",
              });
              if(datos.tipo == 1) {
                this.$local_storage.set("uuid_comercio", datos.uuid);
                this.$router.replace("/carta_porte/administrar/comercio_exterior");
              } else {
                this.$local_storage.set("uuid_carta_porte", datos.uuid);
                this.$router.replace("/carta_porte/administrar/nueva_carta");
              }
            }
          }).catch((error) => {
            console.log(error);
            this.$local_storage.set("uuid_carta_porte", null);
            this.$local_storage.set("uuid_comercio", null);
            this.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al guardar el registro.",
              footer: "",
            });
            this.$root.$dialogLoader.hide();
            this.modal_cecp = false;
          });
        },
        descargarFacturaProformaMETODOANTERIOR: function(){
            this.loadingBtn = true;
            var opt = {
                margin: [0.5, 0.1, 0.5, 0.1], //top, left, bottom, right
                //filename: "Factura_Proforma_"+this.model_proforma.facturas.factura+".pdf",
                filename: this.model_proforma["Folio Fiscal"]+".pdf",
                image: {
                    type: "jpeg",
                    quality: 1
                },
                html2canvas: {
                    scale: 2
                },
                pagebreak: {
                    mode: [ "css", "legacy"]
                },
                jsPDF: {
                    unit: "in",
                    format: "letter",
                    orientation: "portrait", //portrait, landscape
                    compress: false,
                }
            };

            var html = document.getElementById("facturaProforma");
            var thisObj = this;
            html2pdf()
                .set(opt)
                .from(html)
                .save()
                .then(function (pdf2) {
                                    thisObj.loadingBtn = false;
                                })
        },
        downloadProforma: function(key_pdf){
            var datoss3 = {
                id: key_pdf,
                bucket: "facturas.abiertas.econectpro.mx"
            }
            var thisObj = this;
            axios.post(this.$hostname + 's3/download_url/', datoss3)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al generar PDF. Favor de intentar nuevamente.",
                            footer: '',
                        });
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo. Favor de intentar más tarde.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;

                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    this.$root.$dialogLoader.hide();

                });
        },

        downloadFacturaProforma: function(filename, intento=0){
            var nombreZip = filename.toString()+".pdf";
            var key = this.$local_storage.get("rfc")+"/reportes/"+nombreZip;
            var datoss3 = {
                id: key,
                bucket: "production.econnect.ds"
            }

            var thisObj = this;
            axios.post(this.$hostname + 's3/download_url/', datoss3)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        if(intento > 3) {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al generar PDF. Favor de intentar nuevamente.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            setTimeout(function(){
                                thisObj.downloadFacturaProforma(filename, intento+1);
                            }, 10000); //Damos tiempo para generar el zip (10 seg)
                        }

                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo. Favor de intentar más tarde.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;

                    if (mensaje.indexOf("El archivo no existe en S3")!=-1 && intento<=3){
                        setTimeout(function(){
                            thisObj.downloadFacturaProforma(filename, intento+1);
                        }, 10000); //Damos tiempo para generar el zip (10 seg)
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);
                        this.$root.$dialogLoader.hide();
                    }
                });

        },
        descargarFacturaProforma: function(){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var filename = this.model_proforma["Folio Fiscal"];
            var datos = {
                rfc: this.$local_storage.get("rfc"),
                archivo: filename,
                reporte_url: "/reportes_ws/proforma_factura_transito/",
                nombre_reporte: "Proforma Factura en Transito",
                tipo: "Proforma_Factura_Transito",
                usuario: this.$local_storage.get("id_usuario"),
            };
            var thisObj = this;
            axios.post(this.$hostname + "reportes/save_reporte/", datos)
            .then(res => {
                setTimeout(function(){
                    thisObj.downloadFacturaProforma(filename, 1);
                }, 10000); //Damos tiempo para generar el zip (10 seg)
            })
            .catch(error => {
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined){
                    var mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                } else {//Si es un timeout intentamos descargar el archivo
                    setTimeout(function(){
                        thisObj.downloadFacturaProforma(filename, 1);
                    }, 10000); //Damos tiempo para generar el zip (10 seg)
                }
                console.log(error);
            });
        },
        eliminarCFDI: function (id_archivo) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el archivo ?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id: id_archivo,
                    };
                    axios
                        .post(this.$hostname + "reportes/eliminar_factura_abierta_xml/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El archivo se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el archivo. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargar2()
                        });
                }
            });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id: idreporte,
                    };
                    axios
                        .post(this.$hostname + "bandeja_temporal/delete_bitacora_manifestacion_transportista/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargar();
                        });
                }
            });
        },
        eliminarCarta: function (key) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        key: key,
                    };
                    axios
                        .post(this.$hostname + "vucem/eliminar_archivo_adjunto/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargar3();
                        });
                }
            });
        },

        download_pdf: function (key_pdf) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key_pdf,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        refacturar: async function() {
            var self = this;


            self.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");

            this.model_refacturar.emisor =  {
                "Nombre": self.model_refacturar.emisor.razon_social,
                "RegimenFiscal": self.model_refacturar.emisor.regimen,
                "Rfc": self.model_refacturar.emisor.rfc,
                "Domicilio": {
                    "Calle": self.model_refacturar.emisor.domicilio.calle,
                    "CodigoPostal": self.model_refacturar.emisor.domicilio.codigo_postal,
                    "Colonia": self.model_refacturar.emisor.domicilio.colonia,
                    "Estado": self.model_refacturar.emisor.domicilio.estado,
                    "Localidad": self.model_refacturar.emisor.domicilio.localidad,
                    "Municipio": self.model_refacturar.emisor.domicilio.municipio,
                    "NumeroExterior": self.model_refacturar.emisor.domicilio.numero_ext,
                    "Pais": self.model_refacturar.emisor.domicilio.pais,
                    "Referencia": ""
                },
            };

            if (this.model_refacturar.tipo == "Ingreso") {
              this.model_refacturar.receptor = null;
          } else {
            this.model_refacturar.receptor = this.model_refacturar.emisor;
          }

            await axios.post(this.$hostname +'carta_porte/refacturar/', this.model_refacturar)
                .then(async (res) => {
                    if (typeof res.data !== 'undefined') {
                        console.log(res.data);
                        self.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se envío correctamente.",
                            footer: "",
                        });
                        this.$local_storage.set("uuid_carta_porte", this.model_refacturar.uuid);
                        this.$router.replace("/carta_porte/administrar/nueva_carta_refactura");

                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$local_storage.set("uuid_carta_porte", null);
                    self.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al guardar el registro.",
                        footer: "",
                    });
                    self.$root.$dialogLoader.hide();
                    this.model_refacturar = {
                      id:null,
                      emisor:null,
                      receptor:null,
                      uuid_empresa: null,
                      tipo: null,
                      uuid: null
                    };
                    this.modal_refacturar = false;
                });
        },
        cargarReceptores: async function (rfc) {
            let self = this;
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
              var data = {
                    "uuid_empresa": rfc,
                };
            await axios.post(self.URL_C + 'list_clientes/', data)
                .then((res) => {
                if (typeof res.data !== 'undefined') {
                    self.receptores = res.data;
                }
                self.$root.$dialogLoader.hide();
            });
        },
        cargarEmisor: async function (rfc) {
             let self = this;
             this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
              var params = {
                 filtros: {
                   rfc: rfc,
                 },
                 select:{"razon_social": 1, "rfc": 1, "regimen": 1, "domicilio":1}
               };
               await axios.post(this.URL_C + "list_registros_fiscales/", params)
                 .then((res) => {
                 if (typeof res.data !== 'undefined') {

                         self.model_refacturar.emisor = res.data[0];

                     }else{
                        self.$swal({
                         type: "error",
                         title: "Error",
                         text: "Debe dar de alta sus Datos Fiscales.",
                         footer: "",
                     });
                     }
                 self.$root.$dialogLoader.hide();
             });
         },
         preparar_refactura: async function(id) {
           var rfc = "";
           if (this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") == 1) {
              rfc = this.$local_storage.get("rfc_grupo");
            } else {
              rfc = this.$local_storage.get("rfc");
            }

            this.model_refacturar.uuid_empresa = rfc;

            await this.cargarEmisor(rfc);

            if (this.model_refacturar.tipo == "Ingreso") {
              console.log("aqui va vacio");
            } else {
              this.model_refacturar.receptor = this.model_refacturar.emisor;
            }
            console.log("enviar a guardar");
            if(this.model_refacturar.emisor == null) {
              this.model_refacturar.id=null;
              this.modal_refacturar=false;
            } else {
              this.model_refacturar.id=id;
              // Aqui hay que enviar a guardar
              this.model_refacturar.uuid = this.$uuid.v4();
              this.refacturar();
            }
         },
        download: function (row) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var key = row.rfc_grupo + "/archivosM/" + row.nombre_zip;
            if(row.key_s3 != null && row.key_s3!="")
                key = row.key_s3;
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
          async estadisticaGrafica1() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "rfc": this.model.rfc,
                "fecha_de": this.g1_fecha_de,
                "fecha_a":  this.g1_fecha_a,
            }
            await axios.post(this.$hostname + 'reportes/conteos_referencias/', datos)
                .then((response) => {
                    let r = response.data;

                     let tp = 0;

                    let m = [];
                    let vp = [];
                     r.forEach(function(x){
                        m.push(x.mes);
                        vp.push(x.total);
                        tp = tp + x.total;
                     });

                    this.data_grafica1.xAxis.categories = m;
                    this.data_grafica1.series[0].data = vp;


                })
                .catch((error) => {
                    this.data_grafica1.xAxis.categories = [];
                    this.data_grafica1.series[0].data = [];
                    this.totalA_G1 = 0;
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialog11 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        async estadisticaGrafica2() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
             var datos = {
                 "rfc": this.model.rfc,
                "fecha_de": this.g2_fecha_de,
                "fecha_a":  this.g2_fecha_a,
            }
            await axios.post(this.$hostname + 'reportes/conteos_transportistas/', datos)
                .then((response) => {
                   let r = response.data;

                     let tp = 0;

                    let m = [];
                    let vp = [];
                     r.forEach(function(x){
                        m.push(x.nombre);
                        vp.push(x.total);
                        tp = tp + x.total;
                     });

                    this.data_grafica2.xAxis.categories = m;
                    this.data_grafica2.series[0].data = vp;

                })
                .catch((error) => {
                    this.data_grafica2.xAxis.categories = [];
                    this.data_grafica2.series[0].data = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialog22 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        async estadisticaGrafica3() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                 "rfc": this.model.rfc,
                "fecha_de": this.g3_fecha_de,
                "fecha_a":  this.g3_fecha_a,
                "por_grupo": 0
            }
            await axios.post(this.$hostname + 'reportes/conteos_cartaporte_graficas/', datos)
                .then((response) => {
                     let r = response.data;
                 console.log(r)
                     let tp = 0;

                    let m = [];
                    let vp = [];
                     r.forEach(function(x){
                        m.push(x.ruta);
                        vp.push(x.total);
                        tp = tp + x.total;
                     });

                    this.data_grafica3.xAxis.categories = m;
                    this.data_grafica3.series[0].data = vp;

                })
                .catch((error) => {
                    console.log(error);
                    this.data_grafica3.xAxis.categories = [];
                    this.data_grafica3.series[0].data = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialog33 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },

    },
};
</script>


<style scoped>
.footer-hide>>>.VuePagination {
    display: none !important;
}
</style>
